import styled from 'styled-components';

type TextProps = {
  display?: string;
  size?: number;
  padding?: string;
  margin?: string;
  color?: string;
  textAlign?: 'left' | 'right' | 'center' | 'justify';
  cursor?: 'pointer' | 'auto' | 'defaults';
  weight?: 'bold' | 'normal';
  position?: 'absolute' | 'relative' | 'sticky';
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
  background?: string;
  ellipsisOnRow?: number;
};

export const Text = styled.p<TextProps>`
  display: ${({ display }) => display || 'block'};
  font-size: ${({ size }) => `${size}em` || '1em'};
  padding: ${({ padding }) => padding || '0'};
  margin: ${({ margin }) => margin || '0'};
  color: ${({ color, theme }) => color || theme.colors.black};
  text-align: ${({ textAlign }) => textAlign || 'auto'};
  font-weight: ${({ weight }) => weight || 'normal'};
  cursor: ${({ cursor }) => cursor || 'default'};
  position: ${({ position }) => position || 'relative'};
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  bottom: ${({ bottom }) => bottom};
  right: ${({ right }) => right};
  background: ${({ background }) => background ?? 'unset'};

  ${({ ellipsisOnRow }) =>
    ellipsisOnRow &&
    `
      width:100%;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: ${ellipsisOnRow};
      -webkit-box-orient: vertical;
  `}
`;
